import React from "react";
import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";

const stylesText = {
  Driver:
    "People with a Driving SOCIAL STYLE are seen by others as direct, active, forceful and determined. They initiate social interaction and they focus their efforts and the efforts of others on the goals and objectives they wish to get accomplished. Need: Results. Orientation: Action. Growth Action: To Listen",
  Expressive:
    "People with an Expressive Style tend to be more willing to make their feelings known to others. They can appear to react impulsively and openly show both positive and negative feelings. They are typically described by others as personable, talkative and sometimes opinionated. Need: Personal Approval. Orientation: Spontaneity. Growth Action: To Check",
  Amiable:
    "People with an Amiable Style openly display their feelings to others. They appear less demanding and generally more agreeable than others. They are interested in achieving a rapport with others who often describe them as informal, casual and easy going. Need: Personal Security. Orientation: Relationships. Growth Action: To Initiate",
  Analytical:
    "People with an Analytical SOCIAL STYLE are typically described by others as quiet, logical and sometimes reserved or cautious. They tend to appear distant from others and may not communicate unless there is a specific need to do so. Need: To Be Right. Orientation: Thinking. Growth Action: To Declare",
};

const Personality = ({ socialStyles }) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <Typography>Social Style: {socialStyles?.socialStyle}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography>Accuracy: {socialStyles?.accuracy}%</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography>Assertive: {socialStyles?.assertive}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography>Responsive: {socialStyles?.responsive}</Typography>
      </Grid>
      <Grid item xs={12}>
        {socialStyles ? stylesText[socialStyles.socialStyle] : ""}
      </Grid>
    </Grid>
  );
};

export default Personality;
